import React from "react";
import classNames from "classnames";
import Link from "next/link";

import { Author } from "@/custom-types/Wordpress";

import Card from "@/components/botanic/Card";

import BylineImage from "../BylineImage";

const AuthorBoxContent = ({
  name,
  image,
  description,
  urlPath,
}: {
  name: string;
  image: string;
  description: string;
  urlPath?: string;
}) => (
  <>
    <div className="flex flex-row items-center gap-x-3 mb-lg">
      <BylineImage
        src={image}
        alt={name}
        size="large"
        className="flex-shrink-0"
      />
      <span className="text-md font-bold">{name}</span>
    </div>
    <div
      className="block mb-2"
      dangerouslySetInnerHTML={{ __html: description }}
    />
    {urlPath && (
      <Link className="font-bold text-green underline" href={urlPath}>
        View {name}&apos;s articles
      </Link>
    )}
  </>
);

export default ({
  author,
  className,
}: {
  author: Pick<Author, "name" | "image" | "description"> & { urlPath?: string };
  className?: string;
}) => (
  <Card
    className={classNames(className, "border border-light-grey p-lg bg-white")}
  >
    <AuthorBoxContent {...author} />
  </Card>
);
